<template>
  <div>
    Connexion en cours
  </div>
</template>

<script>

export default {
  name: 'RedirectSSOPage',
  components: {
  },

  data: () => ({
  }),

  props: {
  },

  methods: {
  },

  mounted() {
    const redirectPath = encodeURI(window.location.href.split(this.$route.fullPath)[0] + '/saveTokenSSO');
    if (this.$route && this.$route.query && this.$route.query.logout) {
      window.location = `https://sso.s3n.ovh/logout?redirectUrl=${redirectPath}`;
    } else {
      window.location = `https://sso.s3n.ovh/login?redirectUrl=${redirectPath}`;
    }
  }
}
</script>

<style>
</style>